// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3RgOD","reduced":"classes_reduced__35xLs","for-seo":"classes_for-seo__iCM-w","content":"classes_content__3DBqk"};